/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ComputeLogSource = {
  System: "system",
  User: "user",
} as const;
export type ComputeLogSource = ClosedEnum<typeof ComputeLogSource>;

/** @internal */
export const ComputeLogSource$inboundSchema: z.ZodNativeEnum<
  typeof ComputeLogSource
> = z.nativeEnum(ComputeLogSource);
/** @internal */
export const ComputeLogSource$outboundSchema: z.ZodNativeEnum<
  typeof ComputeLogSource
> = ComputeLogSource$inboundSchema;
